export default "__VITE_ASSET__905fce60__"